import { StandardMouseEvent } from 'vscode/vscode/vs/base/browser/mouseEvent';
import { ActionRunner } from 'vscode/vscode/vs/base/common/actions';
import { asArray } from 'vscode/vscode/vs/base/common/arrays';
import { createAndFillInContextMenuActions } from 'vscode/vscode/vs/platform/actions/browser/menuEntryActionViewItem';

class InstanceContext {
    constructor(instance) {
        this.instanceId = instance.instanceId;
    }
    toJSON() {
        return {
            $mid: 15 ,
            instanceId: this.instanceId
        };
    }
}
class TerminalContextActionRunner extends ActionRunner {
    async runAction(action, context) {
        if (Array.isArray(context) && context.every(e => e instanceof InstanceContext)) {
            await action.run(context?.[0], context);
            return;
        }
        return super.runAction(action, context);
    }
}
function openContextMenu(targetWindow, event, contextInstances, menu, contextMenuService, extraActions) {
    const standardEvent = ( new StandardMouseEvent(targetWindow, event));
    const actions = [];
    createAndFillInContextMenuActions(menu, { shouldForwardArgs: true }, actions);
    if (extraActions) {
        actions.push(...extraActions);
    }
    const context = contextInstances ? ( asArray(contextInstances).map(e => ( new InstanceContext(e)))) : [];
    contextMenuService.showContextMenu({
        actionRunner: ( new TerminalContextActionRunner()),
        getAnchor: () => standardEvent,
        getActions: () => actions,
        getActionsContext: () => context,
    });
}

export { InstanceContext, TerminalContextActionRunner, openContextMenu };
